import React, {useState} from "react";
import {Button, Card, Checkbox, Form, Input, Modal} from "antd";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {CheckCircleOutlined, ExclamationCircleOutlined} from "@ant-design/icons";

function ChangePassword() {

    const query = new URLSearchParams(window.location.search);
    const [uuid , setUuid] = useState(query.get("uuid"));
    const [username , setUsername] = useState([]);
    const [password , setPassword] = useState([]);
    const [rePassword , setRePassword] = useState([]);
    const {isLoggedIn} = useSelector(state => state.auth);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const {error} = Modal;


    if(uuid){
        axios("/CreditSystem/ume/resetPasswordGetMail", {
            method: 'POST',
            data: {
                "uuid": uuid
            }
        })
        .then((res) => {
                if (res && res.data && res.data.data) {
                    setUsername(res.data.data);
                    form.setFieldsValue({
                        username: res.data.data,
                        password: null,
                        rePassword: null
                    })
                } else {
                    error({
                        title: 'Hata',
                        icon: <ExclamationCircleOutlined/>,
                        content: "Geçersiz adresten giriş yaptınız!",
                        okText: 'Tamam',
                        onOk() {
                            window.open('/authservice-ui/index.html', "_self");
                        },
                    });
                }
            }
        )
        .catch((err) => {
            console.error(err);
            error({
                title: 'Hata',
                icon: <ExclamationCircleOutlined/>,
                content: "Geçersiz adresten giriş yaptınız!",
                okText: 'Tamam',
                onOk() {
                    window.open('/authservice-ui/index.html', "_self");
                },
            });
        });
    } else {
        error({
            title: 'Hata',
            icon: <ExclamationCircleOutlined/>,
            content: "Geçersiz adresten giriş yaptınız!",
            okText: 'Tamam',
            onOk() {
                window.open('/authservice-ui/index.html', "_self");
            },
        });
    }

    function changePassword(values) {
        const {
            username,
            password,
            rePassword,
        } = values;
        setLoading(true);

        axios("/CreditSystem/ume/resetPassword", {
            method: 'POST',
            data: {
                "uuid": uuid,
                "username": username,
                "password": password,
                "rePassword": rePassword
            }
        })
            .then((res) => {
                    if(res && res.data && res.data.code && res.data.code === "0000"){
                        error({
                            title: 'Başarılı',
                            icon: <CheckCircleOutlined />,
                            content: "Parolanız başarıyla güncellenmiştir!",
                            okText: 'Tamam',
                            onOk() {
                                window.open('/authservice-ui/index.html', "_self");
                            },
                        });
                    } else {
                        error({
                            title: 'Hata',
                            icon: <ExclamationCircleOutlined/>,
                            content: res.data.data,
                            okText: 'Tamam',
                        });
                    }
                }
            )
            .catch((err) => {
                console.error(err);
                error({
                    title: 'Hata',
                    icon: <ExclamationCircleOutlined/>,
                    content: "Sistem Hatası! Lütfen sistem yöneticinize başvurunuz!",
                    okText: 'Tamam',
                });
            });
    }

    return (
        <div className="form_design">
            <Card title="Parola Güncelleme">
                <Form
                    form={form}
                    className='login-form'
                    name="change-password"
                    initialValues={{remember: true}}
                    onFinish={changePassword}

                >
                    <Form.Item
                        name="username"
                        className="input_border"
                        rules={[{required: true, message: 'E-Posta bilgisi boş olamaz'}]}>
                        <Input placeholder='E-Posta' value={username} autoComplete="username" disabled="true"/>
                    </Form.Item>

                    <Form.Item
                        name="password"
                        className="input_border"
                        rules={[{required: true, message: 'Lütfen yeni parolanızı giriniz!'}]}
                        hasFeedback
                    >
                        <Input.Password placeholder='Yeni Parola' value={password}/>
                    </Form.Item>
                    <Form.Item
                        name='rePassword'
                        className="input_border"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'Lütfen Parolanızı Onaylayınız'
                            },
                            ({getFieldValue}) => ({
                                validator(rule, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject('Girilen iki parola eşleşmiyor.')
                                }
                            })
                        ]}
                    >
                        <Input.Password placeholder='Yeni Parola Tekrar' value={rePassword}/>
                    </Form.Item>

                    <Form.Item>
                        <Button size="large" type="primary" htmlType="submit" block>
                            Parola Değiştir
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};


export default ChangePassword;